import { SELECIONAR_PESSOA_REMETENTE } from '../types'

export default function selecionarPessoaRemetente (pessoa) {
  return {
    type: SELECIONAR_PESSOA_REMETENTE,
    payload: pessoa
  }
}
